export default [
    {
        path: '/settings',
        meta: {
            title: "Token",
            icon: "token.png",
            show: true
        },
        component: () => import(/* webpackChunkName: "token" */ '../views/admin/page/TokenPage/Index'),
        redirect: { name: 'token' },
        children: [
            {
                path: 'token',
                name: 'token',
                meta: {
                    title: "Token",
                    show: true
                },
                component: () => import(/* webpackChunkName: "token" */ '../views/admin/page/TokenPage/components/TableComponent'),
            },
            {
                path: 'create',
                name: 'token.create',
                meta: {
                    title: "Token",
                    show: false
                },
                component: () => import(/* webpackChunkName: "token" */ '../views/admin/page/TokenPage/components/FormComponent'),
                props: false
            },
            {
                path: 'edit/:id',
                name: 'token.edit',
                meta: {
                    title: "Token",
                    show: false
                },
                component: () => import(/* webpackChunkName: "token" */ '../views/admin/page/TokenPage/components/FormComponent'),
                props: false
            },
        ]
    }
]